import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"position":"relative","height":"100%"}
}

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'tlCsLine',
  props: {
  content: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props

const styleDiv = computed(() => {
  return [
    {"position" : "absolute"},
    {"height" : "100%"},
    {"left" : props.content.x * 100 + "%"},
    {"border" : "1px dashed"},
    {"border-color" : "var(--main-m)"},
  ]
})


return (_ctx: any,_cache: any) => {
  return (__props.content.x > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          style: _normalizeStyle(styleDiv.value)
        }, null, 4)
      ]))
    : _createCommentVNode("", true)
}
}

})